import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalCacheService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  public saveLocalStorage(keyName: string, jsonObject: any) {
    if (this.isBrowser)
      localStorage.setItem(keyName, JSON.stringify(jsonObject));
  }

  public getLocalStorage(keyName: string) {
    return this.isBrowser ? localStorage.getItem(keyName) || '' : '';
  }

  public saveSessionStorage(keyName: string, jsonObject: any) {
    if (this.isBrowser)
      sessionStorage.setItem(keyName, JSON.stringify(jsonObject));
  }

  public getSessionStorage(keyName: string) {
    const jsonObject = this.isBrowser ? sessionStorage.getItem(keyName) : '';
    try {
      return jsonObject ? JSON.parse(jsonObject) : null;
    } catch {
      return null;
    }
  }

  public removeSessionStorage(keyName: string) {
    if (this.isBrowser) sessionStorage.removeItem(keyName);
  }

  public removeLocalStorage(keyName: string) {
    if (this.isBrowser) localStorage.removeItem(keyName);
  }

  public getSessionStorageObservable(keyName: string): Observable<any> {
    return new Observable((observer) => {
      const jsonObject = this.isBrowser ? sessionStorage.getItem(keyName) : '';
      observer.next(jsonObject ? JSON.parse(jsonObject) : null);
    });
  }

  public clearAllSession() {
    if (this.isBrowser) sessionStorage.clear();
  }
}
